module.exports = __webpack_public_path__ + "img/menu.ee04e32e.svg";